import swal from "sweetalert";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import useUser from "../../../../../core/hooks/use-user";
import useModal from "../../../../../core/hooks/use-modal";
import FormEditarCuadroTurno from "../form-editar-cuadro-turnos";

const BotonEditarTurno = ({ onTurnoAsignado }) => {
    const { userCan } = useUser();
    const modalEditarTurno = useModal();

    const onEditarCuadroTurno = async (response) => {
        let { errors } = response;

        if (errors && errors.length > 0) {
            errors = errors
                .map((err) => `* ${err.empleado} - ${err.fecha_cuadro_turno}`)
                .join("\n");

            await swal({
                icon: "error",
                title: "Error!",
                text: `
                    ${errors} \n
                    Estos turnos no han sido creados ya que se excede el máximo
                    de horas de trabajo que pueden tener estos empleados en esos días
                `,
            });
        }

        onTurnoAsignado();
    };

    if (userCan("nominaEditarTurnoMasivo")) {
        return (
            <>
                <Button
                    color="grey"
                    title="Editar turno"
                    className="ml-2"
                    onClick={() => modalEditarTurno.open()}
                >
                    <i className="fas fa-pen mr-1"></i>
                    Editar turno
                </Button>
                <FormEditarCuadroTurno
                    modalState={modalEditarTurno}
                    onCreate={onEditarCuadroTurno}
                />
            </>
        );
    }

    return <></>;
};

BotonEditarTurno.propTypes = {
    onTurnoAsignado: PropTypes.func,
};

export default BotonEditarTurno;
